






import snackbar from '@/elements/Snackbar.vue'

export default 
	name: 'App'
	
	components:
		'v-snackbar': snackbar

	data: ->
		message: null

	methods:
		showMessage: (msg) ->
			@message = msg
			setTimeout  =>
				@message = null
			, 1000

	mounted: ->
		@$store.dispatch('refresh_login', @$store.state.user) if @$store.state.user.is_logged_in
		@$store.dispatch('getServices')

	# updated: ->
	# 	@$nextTick ->
	# 		componentHandler.upgradeElements @$el
 



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue